exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-modules-tables-components-SimpleFilter-___styles__input___3wVIv {\n  max-width: 12.5rem; }\n", ""]);

// Exports
exports.locals = {
	"input": "src-modules-tables-components-SimpleFilter-___styles__input___3wVIv"
};